export function comparePaths(path1 = '', path2 = '', ignoreUtm = true) {
  if (ignoreUtm) {
    const UTM_REGEX =
      /(\?)utm[^&]*(?:&utm[^&]*)*&(?=(?!utm[^\s&=]*=)[^\s&=]+=)|\?utm[^&]*(?:&utm[^&]*)*$|&utm[^&]*/gi
    path1 = path1.replace(UTM_REGEX, '')
    path2 = path2.replace(UTM_REGEX, '')
  }
  const [pathname1, search1 = ''] = path1.split('?')
  const [pathname2, search2 = ''] = path2.split('?')
  const clientPath1 = MAPPED_SERVER_PATHS[pathname1] || pathname1
  const clientPath2 = MAPPED_SERVER_PATHS[pathname2] || pathname2

  return {
    samePath: clientPath1 === clientPath2,
    sameSearch: search1 === search2,
  }
}

export const ORDER_PAGE = '/pedir'
export const ORDER_PAGE_SERVER = '/order'
export const MAPPED_SERVER_PATHS = {[ORDER_PAGE_SERVER]: ORDER_PAGE}
